import React from 'react';
import TweenOne from 'rc-tween-one';
import ScrollOverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import QueueAnim from 'rc-queue-anim';
import { EnvironmentTwoTone } from '@ant-design/icons';
import { useTranslation } from "react-i18next";

export default function Hubs() {
  const [t, i18n] = useTranslation('global');

  return (
    <ScrollOverPack id="hubs" className="content-wrapper">
      <QueueAnim
        className="text-wrapper left-text"
        key="text"
        duration={450}
        type="bottom"
        leaveReverse
      >
            <h1 className="title-hubs" key="h1">{t('Hubs.title-hubs')}</h1>
            <div key="hubs">
              <ul id="lista">
                <li>{t('Hubs.cross-docking')}</li> |<li>{t('Hubs.micro-cons')}</li><br/> | 
                <li>{t('Hubs.infraestr')}</li>
              </ul>
            </div>
            <div key="points">
              <ul id="points-map">
                <li style={{fontWeight: 'bold'}}>{t('Hubs.españa')}:</li>
                <li> <EnvironmentTwoTone/> {t('Footer.madrid-AM')}</li> 
                <li> <EnvironmentTwoTone/> {t('Footer.madrid-RA')}</li> 
                <li> <EnvironmentTwoTone/> {t('Footer.barcelona-LL')}</li>
                <li> <EnvironmentTwoTone/> {t('Footer.barcelona-RC')}</li>
                <li> <EnvironmentTwoTone/> {t('Footer.valencia')}</li>
                <li> <EnvironmentTwoTone/> {t('Footer.sevilla')} </li>
                <li style={{fontWeight: 'bold'}}>{t('Hubs.portugal')}:</li>
                <li> <EnvironmentTwoTone/> {t('Footer.lisboa')}</li>
              </ul>
            </div>
      </QueueAnim>
      <TweenOne
        key="image"
        className="image2 image-wrapper"
        animation={{ x: 0, opacity: 1, ease: 'easeOutQuad' }}
        style={{ transform: 'translateX(100px)', opacity: 0 }}
      />
    </ScrollOverPack>
  );
}
